import classNames from 'classnames';

import Url from 'types/Url';
import Button, { Props as ButtonProps } from '@components/atoms/Button';

import classes from './Tags.module.scss';

type Props = {
  items: { id: number; name: string; href?: Url; onClick?: () => void }[];
  color?: ButtonProps['color'];
  size?: ButtonProps['size'];
  activeId?: number;
};

const Tags = ({ items, color = 'tertiary', size, activeId }: Props): JSX.Element => (
  <div className={classes.wrapper}>
    <div className={classes.container}>
      {items.map(({ name, id, href, onClick }) => (
        <Button
          key={id}
          className={classNames(classes.button, { [classes.inactive]: activeId === id })}
          href={activeId !== id ? href : undefined}
          onClick={activeId !== id ? onClick : undefined}
          variant={activeId === id ? 'contained' : 'tag'}
          color={activeId === id ? 'tertiary' : color}
          size={size}
          shape="round"
        >
          {name}
        </Button>
      ))}
    </div>
  </div>
);

export default Tags;
